import { getDurationsForConfig } from '../render/renderSceneMetrics';
import {
  LIVE_PHASE_IDLE,
  LIVE_PHASE_PLAYING,
} from '../shared/liveProtocol';

const getResolvedFps = (program) => Math.max(1, Number(program?.fps) || 60);

export const getProgramTiming = (program) => {
  if (!program) return null;
  const fps = getResolvedFps(program);
  const durations = getDurationsForConfig(fps, program.config || {});
  const frameDurationMs = 1000 / fps;
  return {
    fps,
    durations,
    frameDurationMs,
    totalDurationMs: Math.max(frameDurationMs, (durations.totalFrames + 1) * frameDurationMs),
    outroStartMs: (durations.transitionInFrames + durations.stillFrames) * frameDurationMs,
  };
};

export const getEffectivePlaybackElapsedMs = (liveState, now = Date.now()) => {
  if (!liveState?.program) return 0;
  const timing = getProgramTiming(liveState.program);
  if (!timing) return 0;
  let elapsedMs = Math.max(0, Number(liveState.playbackElapsedMs) || 0);
  if (liveState.phase === LIVE_PHASE_PLAYING && Number.isFinite(liveState.playbackStartedAt)) {
    elapsedMs += Math.max(0, now - liveState.playbackStartedAt);
  }
  return Math.min(elapsedMs, timing.totalDurationMs);
};

export const getRemainingPlaybackMs = (liveState, now = Date.now()) => {
  if (!liveState?.program || liveState.phase === LIVE_PHASE_IDLE) return 0;
  const timing = getProgramTiming(liveState.program);
  if (!timing) return 0;
  return Math.max(0, timing.totalDurationMs - getEffectivePlaybackElapsedMs(liveState, now));
};

export const isProgramInOutro = (liveState, now = Date.now()) => {
  if (!liveState?.program || liveState.phase === LIVE_PHASE_IDLE) return false;
  const timing = getProgramTiming(liveState.program);
  if (!timing) return false;
  return getEffectivePlaybackElapsedMs(liveState, now) >= timing.outroStartMs;
};

export const getPlaybackFrame = (liveState, now = Date.now()) => {
  if (!liveState?.program) return null;
  const timing = getProgramTiming(liveState.program);
  if (!timing) return null;
  const elapsedMs = getEffectivePlaybackElapsedMs(liveState, now);
  return Math.max(
    0,
    Math.min(
      timing.durations.totalFrames,
      Math.floor((elapsedMs / 1000) * timing.fps),
    ),
  );
};
